import { Box, Grid, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import Attribute from "./Attribute";
import APINetworkIntelligence from "../../types/APINetworkIntelligence";
import { humanizeDateString } from "../../utilities/formatting";

export default function NetworkIntelligence({
  networkIntelligence,
}: {
  networkIntelligence: APINetworkIntelligence | null;
}) {
  if (!networkIntelligence) {
    return null;
  }

  const { recent_searches: recentSearches } = networkIntelligence;

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" component="h3" sx={{ fontWeight: "normal" }}>
        Network Intelligence
      </Typography>
      <Typography
        component="div"
        sx={{
          color: grey[600],
          fontSize: 14,
          mt: 0.5,
        }}
      >
        Searches for this company across the TrueBiz platform
      </Typography>

      <Box sx={{ mt: 1 }}>
        <Grid
          container
          spacing={2}
          columnSpacing={{ xs: 2, md: 6 }}
          rowSpacing={{ xs: 2, md: 0 }}
          sx={{
            marginTop: 1,
          }}
        >
          <Grid
            size={{
              xs: 12,
              sm: 4,
            }}
          >
            <Attribute label="First seen">
              {humanizeDateString(recentSearches.first_seen_at)}
            </Attribute>
            <Attribute label="Most recently seen">
              {humanizeDateString(recentSearches.most_recent_seen_at)}
            </Attribute>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 4,
            }}
          >
            <Attribute label="Searches in the last 30 days">
              {recentSearches.searches_last_30_days}
            </Attribute>
            <Attribute label="Searches in the last 90 days">
              {recentSearches.searches_last_90_days}
            </Attribute>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 4,
            }}
          >
            <Attribute label="Searches in the last 180 days">
              {recentSearches.searches_last_180_days}
            </Attribute>
            <Attribute label="All time searches">
              {recentSearches.searches_all_time}
            </Attribute>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
